import MotifsController from './motifs.controller';

export default {
    template: require('./motifs.tpl.html'),
    controller: MotifsController
};
